module.exports = __webpack_public_path__ + "img/normal_multiplier_3.c7169bf3.png";